//import { publish } from "lib/hooks/useSubscription"
const setAttr = (attr, attrInfo, args, info, dispatch, multiple) => {
    const a = attr[1]
    const v = attr[2]
    //console.log("ACTION ATTR", `${a}=${v}`)
    info.setAttr(attrs => ({ ...attrs, [a]: v }))
    if (multiple) return info
}
export default setAttr
